// extracted by css-extract-rspack-plugin
export default {"pageGame":"e6uYwj","mask":"Yd1K_M"};